import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import Button from "@/components/base/Button";
import VehicleCard from "@/components/feature/VehicleCard";
import { categoryOptions } from "@/lib/vehicleMeta";
import { useVehiculos } from "@/hooks/usePublicContent";

export default function FleetSection() {
  const fleet = useVehiculos();
  const featured = fleet.filter((vehicle) => vehicle.activo).slice(0, 4);

  return (
    <section data-product-shop className="bg-background-100 py-16 md:py-24">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Nuestra flota"
            title="Unidades listas para tu operación"
            description="Camiones, furgonetas, autobuses y vehículos especiales con disponibilidad y zonas de operación actualizadas."
          />
          <Button to="/flota" variant="outline" size="md" iconRight="ri-arrow-right-line" className="shrink-0">
            Ver catálogo completo
          </Button>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {categoryOptions.map((option) => (
            <Button
              key={option.value}
              to={`/flota/${option.value}`}
              variant="secondary"
              size="sm"
              className="rounded-full"
            >
              {option.label}
            </Button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((vehicle, index) => (
            <VehicleCard key={vehicle.id} vehicle={vehicle} index={index} />
          ))}
        </div>
      </Container>
    </section>
  );
}